import GroupManagement from './GroupManagement';
import RoleManagement from './RoleManagement';
import SKDMaster from './SKDMaster';

const srv = {
  GroupManagement,
  RoleManagement,
  SKDMaster,
};

export default srv;
